<template>
  <g>
    <rect x="4" y="0" width="20" height="20" />
  </g>
</template>
